import React from 'react';
import './SelectionTools.css';

function SelectionTools({ selectionMode, onSelectMode, onClearSelection, selectedCount }) {
  return (
    <div className="selection-tools">
      <div className="tool-group">
        <button
          className={`tool-btn ${selectionMode === 'rectangle' ? 'active' : ''}`}
          onClick={() => onSelectMode(selectionMode === 'rectangle' ? null : 'rectangle')}
          title="Rectangle Selection"
        >
          <svg width="20" height="20" viewBox="0 0 20 20">
            <rect x="3" y="3" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"/>
          </svg>
          <span>Rectangle</span>
        </button>

        <button
          className={`tool-btn ${selectionMode === 'polygon' ? 'active' : ''}`}
          onClick={() => onSelectMode(selectionMode === 'polygon' ? null : 'polygon')}
          title="Lasso Selection"
        >
          <svg width="20" height="20" viewBox="0 0 20 20">
            <path d="M 3,10 Q 5,3 10,5 T 15,8 Q 18,10 16,13 T 10,16 Q 5,17 3,13 Z" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="2,2"/>
          </svg>
          <span>Lasso</span>
        </button>
      </div>

      {selectedCount > 0 && (
        <div className="selection-info">
          <span className="count-badge">{selectedCount} selected</span>
          <button onClick={onClearSelection} className="clear-selection-btn">
            Clear
          </button>
        </div>
      )}
    </div>
  );
}

export default SelectionTools;
